import { Benefits } from "../../../types/Benefits"
import CarrotClient from "../../../lib/carrot-api"
import Settings from "../../../utils/CarrotConfig"
import { RetryConfig } from "../../../utils/ErrorHandling"
import { useQuery, UseQueryResult } from "react-query"
import ResponseError from "../../../utils/ResponseError"
const client = new CarrotClient(Settings.CARROT_BACKEND_URL)
const ENDPOINT = "GetBenefits"

const loadBenefitsData = async (employeeId: number): Promise<Benefits> => {
  return await client.getBenefitsForEmployee(employeeId)
}

export const getBenefitsCacheKey = (employeeId: number): (string | number)[] => [ENDPOINT, employeeId]

export default function useBenefits(employeeId: number): UseQueryResult<Benefits, ResponseError> {
  return useQuery<Benefits, ResponseError>(getBenefitsCacheKey(employeeId), () => loadBenefitsData(employeeId), {
    ...RetryConfig
  })
}
